//  ItemMenu.tsx
import { Link as ReachLink, useLocation } from "react-router-dom";
import { IconType } from "react-icons";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { Flex, Tooltip } from "@chakra-ui/react";
import { useEffect } from "react";
import { SubItemMenuWrapper } from "./SubItemMenuWrapper";
import { useSideNav } from "@/hooks/useSideNav";

export type ItemMenuProps = {
  title: string;
  to: string;
  icon: IconType;
  setIsOpen: VoidFunction;
  isOpen: boolean;
  childrens?: Array<{
    title: string;
    to: string;
    fullTitle?: string;
    id: number;
  }>;
};

export function ItemMenu({
  title,
  to,
  icon: Icon,
  childrens,
  setIsOpen,
  isOpen,
}: ItemMenuProps) {
  const { open, onToggle } = useSideNav();
  const { pathname } = useLocation();

  const getFirstPathSegment = (pathname: string) => {
    const segments = pathname.split("/").filter(Boolean);
    return segments.length > 0 ? `/${segments[0]}` : "/";
  };

  const isActive = getFirstPathSegment(pathname) === to;
  const hasSubmenu = childrens && childrens.length > 0;

  useEffect(() => {
    if (!open && isOpen) {
      setIsOpen();
    }
  }, [open, isOpen, setIsOpen]);
  const handleClick = (e: React.MouseEvent) => {
    if (hasSubmenu) {
      e.preventDefault();

      if (!open) {
        onToggle();
        setTimeout(() => {
          setIsOpen();
        }, 300);
      } else {
        setIsOpen();
      }
    }
  };

  return (
    <Tooltip label={!open ? title : ""} placement="right">
      <li className="flex flex-col transition-all duration-200 ease-out">
        <ReachLink
          to={to}
          onClick={handleClick}
          className={`
    group flex items-center text-[13px] outline-none
    transition-all duration-200 ease-out rounded-buttons
    h-[30px]
    hover:no-underline hover:bg-surface-hover
    focus-visible:shadow-focus focus-visible:outline-none
    ${
      isActive
        ? "bg-surface-hover text-text-primary shadow-hover"
        : "text-text-inverted hover:text-text-primary"
    }
    ${!open ? "justify-center max-w-[60px] items-center" : "px-2.5"}
  `}
          style={{
            width: !open ? "60px" : "auto",
          }}
          aria-current={isActive ? "page" : undefined}
        >
          <Flex
            align="center"
            className={`flex-1 min-w-0 ${!open && "justify-center"}`}
          >
            {/* ICONE */}
            <Icon
              className={`
      shrink-0 transition-all flex-grow duration-200 text-md
      ${
        isActive
          ? "text-primary-DEFAULT"
          : "text-text-inverted group-hover:text-text-primary"
      }
    `}
            />
            {/* TITULO */}
            <div
              className={`
        transition-all duration-200 ease-out overflow-hidden whitespace-nowrap ml-2.5
        ${open ? "w-auto opacity-100" : "w-0 opacity-0"}
      `}
            >
              <span className="block w-[180px] whitespace-nowrap overflow-hidden text-ellipsis">
                {title}
              </span>
            </div>
          </Flex>
          {/* TOGGLE ICON */}
          {hasSubmenu && (
            <div className="flex shrink-0 w-fit justify-center">
              {isOpen ? (
                <IoIosArrowDown
                  className={`
          transition-all duration-200 text-sm
          ${isActive ? "text-text-primary" : "text-text-primary group-hover:text-text-primary"}
        `}
                />
              ) : (
                <IoIosArrowForward
                  className={`
          transition-all duration-200 text-sm
          ${isActive ? "text-primary-DEFAULT" : "text-text-inverted group-hover:text-text-primary"}
        `}
                />
              )}
            </div>
          )}
        </ReachLink>

        {hasSubmenu && isOpen && (
          <SubItemMenuWrapper open={isOpen && open} items={childrens} />
        )}
      </li>
    </Tooltip>
  );
}
